import { gql } from '@apollo/client';

export const FETCH_USER_LATEST_INTEGRATION_FORM_AGREEMENT = gql`
  query fetchUser($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        firstName
        lastName
        primaryEmail
        latestFormAgreements {
          id
          type
          integrations {
            iid
            externalData
          }
        }
      }
    }
  }
`;

export const UPDATE_INTEGRATION_FORM_AGREEMENT = gql`
  mutation sendIntegrationFormAgreement(
    $input: SendIntegrationFormAgreementInput!
  ) {
    sendIntegrationFormAgreement(input: $input) {
      formAgreement {
        id
      }
    }
  }
`;
